<template>

  <section class="section is-medium">
    <div class="container " style="max-width:1000px">
      <div class="columns is-8" style="align-items:center;">
        <div class="column is-6">
          <div style="padding-bottom:50px">
            <h2 class="title is-1">{{content.title}}
              <i class="fas fa-map-marker-alt"></i>
            </h2>
            <p class="subtitle is-5"> We are proud to welcome you to our brand new studio in Costa Mesa.
            </p>
            <p class="subtitle is-5"> <strong>936 W 17th St., Costa Mesa, CA, 92627 </strong>
            </p>
          </div>
        </div>
        <div class="column is-6">
          <div>
            <iframe width="100%" height="300" frameborder="0" style="border:0" class="effect7" src="https://www.google.com/maps/embed/v1/place?q=936+W+17th+CostaMesa,NewportBeach+USA&key=AIzaSyDlTHZ-x1jYpY1PsE5ZaXUeVWsxYChuqlY"
              allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  export default {
    name: 'Location',
    props: ['content']

  }
</script>

<style scoped>
.effect7
{
    position:relative;
    -webkit-box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
       -moz-box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
            box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
}
.effect7:before, .effect7:after
{
    content:"";
    position:absolute;
    z-index:-1;
    -webkit-box-shadow:0 0 20px rgba(0,0,0,0.8);
    -moz-box-shadow:0 0 20px rgba(0,0,0,0.8);
    box-shadow:0 0 20px rgba(0,0,0,0.8);
    top:0;
    bottom:0;
    left:10px;
    right:10px;
    -moz-border-radius:100px / 10px;
    border-radius:100px / 10px;
}
.effect7:after
{
    right:10px;
    left:auto;
    -webkit-transform:skew(8deg) rotate(3deg);
       -moz-transform:skew(8deg) rotate(3deg);
        -ms-transform:skew(8deg) rotate(3deg);
         -o-transform:skew(8deg) rotate(3deg);
            transform:skew(8deg) rotate(3deg);
}
</style>